import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import React from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { useNavigate } from "react-router-dom";

const BackButton = ({ path }: { path: string }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <IconButton
        onClick={() => navigate(path)}
        sx={{
          bgcolor: "primary.main",
          color: "white",
          "&:hover": {
            bgcolor: "primary.dark",
          },
          mb: 2,
        }}
      >
        <ArrowBackIosNewRoundedIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default BackButton;
